import { useEffect, useState } from 'react'
import { styled } from 'styled-components'
import Card from '../components/education/Card'

interface Prop {
    setTitle: React.Dispatch<React.SetStateAction<string>>
}
const Button = styled.div<{ selected?: boolean }>`
    width: 120px;
    display: flex;
    justify-content: center;
    padding: 10px;
    border-bottom: ${(props) => (props.selected ? '#31c690' : '#ffffff')} 3px
        solid;
    &:hover {
        cursor: pointer;
    }
`

const ButtonsWrapper = styled.div`
    display: flex;
    padding: 0 30px;
`

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 30px;
    background-color: #ffffff;
    border-radius: 10px;
`

const data = [
    {
        id: -1,
        label: 'All',
    },
    {
        id: 0,
        label: 'Foundation',
        imgUrl: './images/education/foundation.png',
        text: {
            p1: 'Practise fundamental movement skills and movement sequences using different body parts and in response to stimuli in indoor, outdoor and aquatic settings (VCHPEM064)',
            linkText: '(VCHPEM064)',
            link: 'https://victoriancurriculum.vcaa.vic.edu.au/Curriculum/ContentDescription/VCHPEM064',
            p2: 'Students perform fundamental movement skills.',
        },
    },
    {
        id: 1,
        label: 'Level 1-2',
        imgUrl: './images/education/level-1-2.png',
        text: {
            p1: 'Perform fundamental movement skills in different movement situations in indoor, outdoor and aquatic settings (VCHPEM080)',
            linkText: '(VCHPEM080)',
            link: 'https://victoriancurriculum.vcaa.vic.edu.au/Curriculum/ContentDescription/VCHPEM080',
            p2: 'Students demonstrate fundamental movement skills in different movement situations.',
        },
    },
    {
        id: 2,
        label: 'Level 3-4',
        imgUrl: './images/education/level-3-4.png',
        text: {
            p1: 'Practise and refine fundamental movement skills in different movement situations in indoor, outdoor and aquatic settings (VCHPEM097)',
            linkText: '(VCHPEM097)',
            link: 'https://victoriancurriculum.vcaa.vic.edu.au/Curriculum/ContentDescription/VCHPEM097',
            p2: 'Students perform fundamental movement skills.',
        },
    },
    {
        id: 3,
        label: 'Level 5-6',
        imgUrl: './images/education/level-5-6.png',
        text: {
            p1: 'Practise specialised movement skills and apply them in different movement situations in indoor, outdoor and aquatic settings (VCHPEM115)',
            linkText: '(VCHPEM115)',
            link: 'https://victoriancurriculum.vcaa.vic.edu.au/Curriculum/ContentDescription/VCHPEM115',
            p2: 'Students perform specialised movement skills.',
        },
    },
    {
        id: 4,
        label: 'Level 7-8',
        imgUrl: './images/education/level-7-8.png',
        text: {
            p1: 'Use feedback to improve body control and coordination when performing specialised movement skills (VCHPEM133)',
            linkText: '(VCHPEM133)',
            link: 'https://victoriancurriculum.vcaa.vic.edu.au/Curriculum/ContentDescription/VCHPEM133',
            p2: 'Students demonstrate control and accuracy when performing specialised movement skills.',
        },
    },
    {
        id: 5,
        label: 'Level 9-10',
        imgUrl: './images/education/level-9-10.png',
        text: {
            p1: 'Perform and refine specialised movement skills in challenging movement situations (VCHPEM152)',
            linkText: '(VCHPEM152)',
            link: 'https://victoriancurriculum.vcaa.vic.edu.au/Curriculum/ContentDescription/VCHPEM152',
            p2: 'Students apply criteria to make judgments about and refine their own and others’ specialised movement skills and movement performances.',
        },
    },
]

const ContentWrapper = styled.div`
    padding: 30px;
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    justify-content: space-evenly;
`

const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 60px;
    gap: 20px;
`

const Header = styled.div`
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    border-bottom: 1px solid #e5e6eb;
`

export default function Education({ setTitle }: Prop) {
    useEffect(() => {
        setTitle('Education')
    }, [])
    const [selectedButton, setSelectedButton] = useState(data[0])

    return (
        <Wrapper>
            <Header>
                Curriculum | Explore all levels from Foundation through 9–10 in
                one place
            </Header>

            <ButtonsWrapper>
                {data.map((d, i) => {
                    return (
                        <Button
                            key={i}
                            onClick={() => setSelectedButton(d)}
                            selected={selectedButton.id === d.id}
                        >
                            {d.label}
                        </Button>
                    )
                })}
            </ButtonsWrapper>
            <ContentWrapper>
                {data.map((d, i) => {
                    if (d.id === -1) return null
                    if (d.id === selectedButton.id || selectedButton.id === -1)
                        return (
                            <Card
                                label={d.label}
                                image={d.imgUrl}
                                text={d.text}
                            />
                        )
                })}
            </ContentWrapper>
        </Wrapper>
    )
}
